import {
  Box,
  Button,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Paper,
  Select,
} from '@mui/material';
import React, { useState } from 'react';

const DeployAppOnEks = () => {
  const [selectedCluster, setSelectedCluster] = useState('');
  const [selectedApp, setSelectedApp] = useState('');

  const clusters = ['eks-dev-cluster', 'eks-prod-cluster', 'eks-staging-cluster'];
  const apps = ['redis (with k8s chart)', 'mysql', 'ansible playbook', 'nginx'];

  const handleClusterChange = (event) => {
    setSelectedCluster(event.target.value);
  };

  const handleAppChange = (event) => {
    setSelectedApp(event.target.value);
  };

  const handleDeploy = () => {
    console.log('Deploying', selectedApp, 'on', selectedCluster);
  };

  return (
    <Box className="k8s-box">
      <Paper elevation={3} className="k8s-paper">
        <Grid container spacing={3} className="k8s-grid">
          <Grid item xs={12} md={6}>
            <FormControl fullWidth>
              <InputLabel>Choose the k8s cluster</InputLabel>
              <Select
                value={selectedCluster}
                onChange={handleClusterChange}
                label="Choose the k8s cluster"
              >
                {clusters.map((cluster) => (
                  <MenuItem key={cluster} value={cluster}>
                    {cluster}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12} md={6}>
            <FormControl fullWidth>
              <InputLabel>Choose the k8s app</InputLabel>
              <Select
                value={selectedApp}
                onChange={handleAppChange}
                label="Choose the k8s app"
              >
                {apps.map((app) => (
                  <MenuItem key={app} value={app}>
                    {app}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12}>
            <Box display="flex" justifyContent="center" my={2}>
              <Button
                variant="contained"
                color="primary"
                onClick={handleDeploy}
                disabled={!selectedCluster || !selectedApp}
              >
                Deploy
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Paper>
    </Box>
  );
};

export default DeployAppOnEks;
